import { render } from "./PublicDatasetCard.vue?vue&type=template&id=e1bce898&scoped=true"
import script from "./PublicDatasetCard.vue?vue&type=script&lang=js"
export * from "./PublicDatasetCard.vue?vue&type=script&lang=js"

import "./PublicDatasetCard.vue?vue&type=style&index=0&id=e1bce898&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1bce898"]])

export default __exports__